// Add entities (normalizr data)
export const ADD_ENTITIES = 'ADD_ENTITIES';
export const CLEAR_ENTITIES = 'CLEAR_ENTITIES';
